(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-split"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('a[data-hero-scroll]');
      if (!link) return;
      var hash = link.getAttribute('href') || '';
      if (hash.charAt(0) !== '#' || hash.length < 2) return;
      var key = hash.slice(1);
      var target = document.getElementById(key);
      if (!target) {
        // Repli : retrouve la section par la fin de son identifiant (template--123__clé)
        var shortKey = key.split('__').pop();
        target = document.querySelector('[id^="shopify-section-"][id$="__' + shortKey + '"]') ||
          document.getElementById('shopify-section-' + shortKey);
      }
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = target.getBoundingClientRect().top + window.pageYOffset - 16;
      window.scrollTo({ top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth' });
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hiver-bar"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-hv-dir]');
    if (!button) return;
    var bar = button.closest('[data-hv-bar]');
    var track = bar && bar.querySelector('[data-hv-track]');
    if (!track) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({
      left: track.clientWidth * 0.8 * Number(button.getAttribute('data-hv-dir')),
      behavior: reduce ? 'auto' : 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["univers-editorial"]) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.uaInit) return;
      root.dataset.uaInit = '1';
      if (!('IntersectionObserver' in window)) return;
      root.classList.add('is-armed');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            root.classList.add('is-visible');
            io.disconnect();
          }
        });
      }, { threshold: 0.15 });
      io.observe(root);
    }
    function run() {
      document.querySelectorAll('[data-ua-univers]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
